import React from "react";
import styles from "./index.module.css";
import { useTranslation } from "react-i18next";
import { TRIP_STATUS } from "../../../helpers/constants";
import SwipeButton from "../../../Components/SwipeButton";
import { FaRegStickyNote } from "react-icons/fa";

const DestinationDetails = ({
  destinationDetails,
  activeStep,
  handleMultiComplete,
  handleClickNotes,
  shifterType,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {destinationDetails.map((item, key) => (
        <div
          className={styles["patient-transport__data-container--location"]}
          key={key}
        >
          <label
            className={
              styles["patient-transport__data-container--location__area"]
            }
          >
            {item?.area?.name}
            {item?.notes && (
              <FaRegStickyNote
                color="#2c4861"
                size={16}
                onClick={() => handleClickNotes(item?.notes)}
              />
            )}
          </label>
          <label
            className={
              styles["patient-transport__data-container--location__building"]
            }
          >
            {`${item?.floor?.name}, ${item?.building?.name}`}
          </label>
          {destinationDetails?.length > 1 &&
            activeStep === 4 &&
            item?.status === TRIP_STATUS.BOOKED &&
            shifterType === "primary" && (
              <SwipeButton
                label={t("Arrived")}
                onComplete={() => handleMultiComplete(item?.area?.id)}
                applyRest
              />
            )}
          {item?.status === TRIP_STATUS.COMPLETE && (
            <span className={styles["patient-transport__complete"]}>
              {t("Destination Covered")}
            </span>
          )}
        </div>
      ))}
    </>
  );
};
export default DestinationDetails;
